<!-- 裁判列表 -->
<template>
    <div>
        <div class="mt-1">
            <el-table :data="refereeList" highlight textcenter style="width: 100%">
                <el-table-column label="序号" type="index" align="center"></el-table-column>
                <el-table-column label="头像" align="center">
                    <template slot-scope="scope">
                        <el-image :src="scope.row.avatar" style="width: 50px;height:50px"></el-image>
                    </template>
                </el-table-column>
                <el-table-column label="裁判名称" prop="realName" align="center"></el-table-column>
                <el-table-column label="联系电话" prop="mobile" align="center"></el-table-column>
                <el-table-column label="身份证号码" prop="idCard" align="center"></el-table-column>
                <el-table-column label="足球行ID" prop="personNo" align="center"></el-table-column>
                <el-table-column label="备注" prop="remark" align="center"></el-table-column>
            </el-table>
            <el-pagination layout="total, prev, pager, next" :current-page="pageInfo.page"
            :page-size="pageInfo.pageSize" :total="pageInfo.count"
            @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
        </div>
    </div>
</template>
<script>
export default {
    components: {},
    data() {
        return {
            teamId: '',
            refereeList: [],
            matchList: [],
            matchInfo: {},
            pageInfo: {
                page: 1,
                pageSize: 10,
                count: 0,
            },
    
        };
    },
    mounted() {
        if (localStorage.getItem('matchId')) {
            this.matchInfo = localStorage.getItem('currentMatchId') ? JSON.parse(localStorage.getItem('currentMatchId')) : {};
            this.getRefereeList()
        } else {
            this.$confirm('暂无赛事！！', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            })
        }
    },
    methods: {
        // 获取裁判列表
        async getRefereeList() {
            const { res } = await this.$http.get(`/Match/RefereeList/${this.matchInfo.matchId}`);
            this.refereeList = res.data || [];
            this.pageInfo.count = res.data.length;
        },
        //分页
        handleSizeChange(val) {
            this.pageInfo.pageSize = val;
            this.getTeamList();
        },
        handleCurrentChange(val) {
            this.pageInfo.page = val;
            console.log(1111, val)
            this.getTeamList();
        },
    },
};
</script>
<style lang="scss" scoped>
/deep/.el-input--small .el-input__inner {
    color: #e9e9e9;
}
</style>